export default function ProductionReducer(state = {}, action) {
    switch (action.type) {
        case "GET_DISASSEMBLY_LIST":
            return {
                ...state,
                disassemblySearchList: action.data
            }
        case "DISASSEMBLY_SEARCH_FILTERS":
            return {
                ...state,
                disassemblySearchFilters: action.data
            }
        case "SEARCH_BOM":
            return {
                ...state,
                bomSearchList: action.data
            }
        case "BoM_SEARCH_FILTERS":
            return {
                ...state,
                bomSearchFilters: action.data
            }
        default:
            return state;
    }
}